import { createFileRoute } from "@tanstack/react-router";

import { OrderFormPage } from "../../../../features/purchasing/order-form-page";

export const Route = createFileRoute("/_app/purchasing/orders/new")({ component: OrderFormPage });
